import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { base64ToFile, ImageCroppedEvent } from "ngx-image-cropper";
import { Observable } from "rxjs";
import { GuruImageCropperService } from "./service/guru-image-cropper.service";

@Component({
    selector: "guru-image-cropper",
    templateUrl: "./image-cropper.component.html",
    styleUrls: ["./image-cropper.component.scss"]
})
export class GuruImageCropperComponent {
    public show$: Observable<boolean>;
    public rounded$: Observable<boolean>;
    public width$: Observable<number>;
    public height$: Observable<number>;
    public fileToCrop$: Observable<File>;

    @ViewChild("inputFile")
    public inputFile: ElementRef<HTMLInputElement>;

    constructor(private guruCropperService: GuruImageCropperService) {
        this.show$ = this.guruCropperService.showAsync();
        this.rounded$ = this.guruCropperService.roundedAsync();
        this.width$ = this.guruCropperService.widthAsync();
        this.height$ = this.guruCropperService.heightAsync();
        this.fileToCrop$ = this.guruCropperService.fileToCropAsync();
    }

    croppedImage: any = "";

    public close() {
        this.guruCropperService.cancel();
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
    }

    imageLoaded() {
        // show cropper
    }
    cropperReady() {
        // cropper ready
    }
    loadImageFailed() {
        // show message
    }

    salvar() {
        var file = base64ToFile(this.croppedImage);

        this.guruCropperService.run(file);
    }
}
